import React from 'react'
import { Button, Form } from 'react-bootstrap'

import hash from 'object-hash'
import { t_caps } from 'src/lib/constants'
import CapsRenderer from 'src/components/access_levels/caps_renderer'
import { getConstants } from 'src/lib/constants'
import { Trans } from 'react-i18next'

class CapsForm extends React.Component {
  static defaultProps = {
    is_management: false,
    user: {},
    onSave: () => {},
    closeForm: () => {},
  }

  state = {
    id: null,
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    is_management_account: false,
    business_role_id: null,
    enabled: true,
    caps: {},
    parent_user: null,
    areas_competence: [],
    brands: [],
    user_data: {
      business_name: '',
      pec: '',
      email: '',
      phone: '',
      piva: '',
      cf: '',
      cuu: '',
      address: '',
      city: '',
      province: '',
      cap: '',
      country: '',
      place_id: '',
    },

    user_hash: '',
  }

  initialHash = ''
  tCaps = getConstants().t_caps

  constructor(props) {
    super(props)
    this.state.caps = Object.keys(t_caps).reduce((acc, k) => ({ ...acc, [k]: true }), {})
    if (props.user.id) {
      let {
        id,
        username,
        first_name,
        last_name,
        email,
        enabled,
        business_role_id,
        is_management_account,
        caps,
        user_data,
        parent_user,
        areas_competence,
        brands,
      } = props.user
      this.state.id = id
      this.state.username = username
      this.state.first_name = first_name
      this.state.last_name = last_name
      this.state.email = email
      this.state.enabled = enabled
      this.state.is_management_account = is_management_account
      this.state.business_role_id = business_role_id
      this.state.user_data = user_data
      this.state.caps = caps
      this.state.parent_user = parent_user || null
      this.state.areas_competence = areas_competence || []
      this.state.brands = brands || []
    }

    // eslint-disable-next-line no-unused-vars
    let { user_hash, ...rest } = this.state
    this.initialHash = hash(rest)
    this.state.user_hash = this.initialHash
  }

  updateHash = () => {
    // eslint-disable-next-line no-unused-vars
    let { user_hash, ...rest } = this.state
    this.setState({ user_hash: hash(rest) })
  }

  handleChangeCaps = (name, checked) => {
    this.setState({ caps: { ...this.state.caps, [name]: checked } }, () => this.updateHash())
  }

  handleConfirm = () => {
    // eslint-disable-next-line no-unused-vars
    let { user_hash, parent_user, ...rest } = this.state
    this.props.onSave({ ...rest, parent_user: parent_user ? parent_user.id : null })
  }

  render() {
    let { caps } = this.state

    return (
      <>
        <div className="flex-fill position-relative overflow-auto">
          <div className="w-100 ps-1 pe-4">
            {this.props.is_management && (
              <Form.Group className="mb-3 mt-5">
                <Form.Label as="h5">
                  <Trans i18nKey="components.users.permissions">Permessi</Trans>
                </Form.Label>
                <CapsRenderer caps={caps} handleChange={this.handleChangeCaps} />
              </Form.Group>
            )}
          </div>
        </div>
        <div className="border-top pt-2">
          <Button
            className="float-end"
            variant="primary"
            disabled={this.initialHash === this.state.user_hash}
            onClick={this.handleConfirm}>
            <Trans i18nKey="buttons.confirm">Conferma</Trans>
          </Button>
          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
        </div>
      </>
    )
  }
}
export default CapsForm
